import { useEffect, type RefObject } from 'react';

interface UseScrollPaginationProps {
  loadMore: () => void | Promise<void>;
  hasMore: boolean;
  isLoading: boolean;
  threshold?: number;
  containerRef?: RefObject<HTMLElement | null>;
}

export function useScrollPagination({
  loadMore,
  hasMore,
  isLoading,
  threshold = 200,
  containerRef,
}: UseScrollPaginationProps) {
  useEffect(() => {
    const handleScroll = () => {
      if (isLoading || !hasMore) return;

      let isNearBottom = false;

      if (containerRef && containerRef.current) {
        const element = containerRef.current;
        isNearBottom =
          element.scrollHeight - element.scrollTop <=
          element.clientHeight + threshold;
      } else {
        isNearBottom =
          window.innerHeight + window.scrollY >=
          document.documentElement.scrollHeight - threshold;
      }

      if (isNearBottom) {
        void loadMore();
      }
    };

    const target = containerRef?.current || window;
    target.addEventListener('scroll', handleScroll);
    return () => target.removeEventListener('scroll', handleScroll);
  }, [loadMore, hasMore, isLoading, threshold, containerRef]);
}
